import { blue, Palette } from '@ant-design/colors'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { ConditionalWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Card, Flex, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Text } = Typography

interface Props {
  item: any
  color?: Palette
  displayMode?: 'card' | 'list'
}

const SettingsCard = ({ item, color, displayMode = 'card' }: Props) => {
  if (!color) {
    color = blue
  }
  return (
    <Link to={`/settings/${item.url}`}>
      <ConditionalWrapper
        condition={displayMode == 'card'}
        wrapper={(children) => (
          <Card style={{ height: '100%' }} styles={{ body: { padding: 16 } }}>
            {children}
          </Card>
        )}
      >
        <Flex gap={displayMode == 'card' ? 16 : 10} align="center">
          <Flex
            align="center"
            justify="center"
            style={{
              width: displayMode == 'card' ? 40 : 25,
              height: displayMode == 'card' ? 40 : 25,
              backgroundColor: color[4],
              borderRadius: item.category === 'tools' ? 50 : 8,
              padding: 8,
            }}
          >
            <Text
              style={{
                color: 'white',
                fontSize: displayMode == 'card' ? 22 : 18,
              }}
            >
              <SBIcon name={item.iconPage} />
            </Text>
          </Flex>
          <Space orientation="vertical" size={0}>
            <Text style={{ fontWeight: 'bold' }}>{item.title}</Text>
            <Text type="secondary">{item.description}</Text>
          </Space>
        </Flex>
      </ConditionalWrapper>
    </Link>
  )
}

export { SettingsCard }
